import React, { useEffect, useState } from 'react';
import { Users, Briefcase, FileText, Star } from 'lucide-react';
import { adminApi } from '../../services/api';
import { Skeleton } from '../../components/ui/Skeleton';

export const AdminDashboard: React.FC = () => {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.dashboard().then((res) => {
      setStats(res.data);
      setLoading(false);
    });
  }, []);

  const kpiCards = [
    { label: 'Total Usuarios', value: stats?.total_users || 0, icon: <Users className="w-5 h-5" />, change: `+${stats?.new_users_this_week || 0} esta semana` },
    { label: 'Trabajos', value: stats?.total_jobs || 0, icon: <Briefcase className="w-5 h-5" />, change: `+${stats?.new_jobs_this_week || 0} esta semana` },
    { label: 'Propuestas', value: stats?.total_proposals || 0, icon: <FileText className="w-5 h-5" />, change: 'Total histórico' },
    { label: 'Rating Promedio', value: stats?.average_rating ? parseFloat(stats.average_rating).toFixed(1) : '0.0', icon: <Star className="w-5 h-5" />, change: `${stats?.total_reviews || 0} reviews` },
  ];

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-onSurface">Panel Administrativo</h1>
        <p className="text-onSurface-mute">Gestión completa de la plataforma</p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {loading
          ? Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="bg-surface rounded-2xl border border-outlineVarWarm p-5">
                <Skeleton className="w-10 h-10 rounded-lg mb-3" />
                <Skeleton className="h-8 w-16 mb-2" />
                <Skeleton className="h-4 w-24" />
              </div>
            ))
          : kpiCards.map((card) => (
              <div key={card.label} className="bg-surface rounded-2xl border border-outlineVarWarm p-5">
                <div className="w-10 h-10 rounded-xl bg-primary-50 text-primary-600 flex items-center justify-center mb-3">
                  {card.icon}
                </div>
                <p className="text-2xl font-bold text-onSurface">{card.value}</p>
                <p className="text-sm text-onSurface-mute">{card.label}</p>
                <p className="text-xs text-success-600 mt-1 font-medium">{card.change}</p>
              </div>
            ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-surface rounded-2xl border border-outlineVarWarm p-6">
          <h2 className="text-lg font-semibold text-onSurface mb-4">Trabajos por categoría</h2>
          {loading ? (
            <Skeleton className="h-48" />
          ) : stats?.jobs_by_category?.length > 0 ? (
            <div className="space-y-3">
              {stats.jobs_by_category.map((cat: any) => (
                <div key={cat.name} className="flex items-center gap-3">
                  <span className="text-sm text-onSurface-var w-32 truncate">{cat.name}</span>
                  <div className="flex-1 h-2 bg-surface-var rounded-full overflow-hidden">
                    <div
                      className="h-full bg-primary-500 rounded-full transition-all"
                      style={{ width: `${Math.min((cat.count / (stats.total_jobs || 1)) * 100 * 4, 100)}%` }}
                    />
                  </div>
                  <span className="text-sm font-medium text-onSurface w-8 text-right">{cat.count}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-onSurface-mute text-center py-8">No hay datos disponibles</p>
          )}
        </div>

        <div className="bg-surface rounded-2xl border border-outlineVarWarm p-6">
          <h2 className="text-lg font-semibold text-onSurface mb-4">Usuarios por mes</h2>
          {loading ? (
            <Skeleton className="h-48" />
          ) : stats?.users_by_month?.length > 0 ? (
            <div className="space-y-3">
              {stats.users_by_month.map((item: any) => (
                <div key={item.month} className="flex items-center gap-3">
                  <span className="text-sm text-onSurface-var w-20">{item.month}</span>
                  <div className="flex-1 h-2 bg-surface-var rounded-full overflow-hidden">
                    <div
                      className="h-full bg-primary-600 rounded-full transition-all"
                      style={{ width: `${Math.min((item.count / 20) * 100, 100)}%` }}
                    />
                  </div>
                  <span className="text-sm font-medium text-onSurface w-8 text-right">{item.count}</span>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-onSurface-mute text-center py-8">No hay datos disponibles</p>
          )}
        </div>
      </div>
    </div>
  );
};
